import React from "react";

/**
 * ErrorBoundary
 */
interface ErrorBoundaryProps {
    children: React.ReactNode;
  }
  
  interface ErrorBoundaryState {
    hasError: boolean;
  }
  
  class ErrorBoundary extends React.Component<ErrorBoundaryProps, ErrorBoundaryState> {
      constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false };
      }
    
      componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
        console.error('Error caught by boundary:', error, errorInfo);
      }
    
      render() {
        if (this.state.hasError) {
          return <div className="alert alert-danger">Une erreur est survenue lors du chargement des fichiers.</div>;
        }
        return this.props.children;
      }
    }

export default ErrorBoundary;